<template>
  <div v-if="currentState"
       class="state-selector asd-input"
       :class="{'asd-input-disabled': visibility > 0}"
  >
    <div :style="{color: currentState.color}"
         @click="tryToShowEditor()"
    >
      <i class="fas fa-bullseye"></i>
      {{ currentState.label }}
    </div>
    <Modal v-if="showEditor">
      <template #default>
        <EntityStateEditor
          :value="value"
          class="asd-form"
          :graphId="graphId"
          @done="showEditor = false"
          @input="editorValueChange"
        ></EntityStateEditor>
      </template>
      <template #controls>
        <button class="asd-btn-cancel"
                @click="showEditor = false"
        >
          Zavřít
        </button>
      </template>
    </Modal>
  </div>
</template>

<script>
import DataTypeMixin from 'CORE/mixins/dataType'
import { createDataTypeValue } from '../utils'
import { get, head, filter, isString } from 'lodash'
import Modal from 'CORE/components/modal/modal'
import EntityStateEditor from 'CORE/components/entity-states/editor'
import EventBus from 'CORE/bus'

export default {
    name: 'EntityStateInput',
    components: {
        Modal,
        EntityStateEditor,
    },
    mixins: [
        DataTypeMixin,
    ],
    data() {
        return {
            showEditor: false,
            data: {},
        }
    },
    computed: {
        valueHandler: {
            get() {
                return get(this, 'value.value.value', null)
            },
            set(value) {
                console.info(value)
                this.$emit('input', createDataTypeValue(value))
            },
        },
        graph() {
            const graph = get(this.$store.getters.currentUser, `company.settings.entity-states.graphs.${this.graphId}`, {})
            return graph
        },
        graphId() {
            return get(this.meta, `entityType.settings.graphs.${this.id}`, {})
        },
        states() {
            return get(this.$store.getters.currentUser, `company.settings.entity-states.states`, {})
        },
        currentState() {
            return head(filter(this.states, s => s.id === this.valueHandler))
        },
        availableConnections() {
            return filter(this.graph.connections, c => {
                return c.from === this.valueHandler
            })
        },
    },
    created() {
        console.assert(isString(this.valueHandler), 'value handler musi byt string')
        if (this.value === null || !isString(this.valueHandler)) {
            this.valueHandler = get(this.graph, 'defaultState')
        }
    },
    methods: {
        editorValueChange(e) {
            this.$emit('input', e)
        },
        tryToShowEditor(e) {
            if (this.editType === 'new') {
                EventBus.$emit('FLASH_USER_ERROR', { message: 'Nelze editovat stav při zakládání nového projektu nebo úkolu.' })
            } else {
                this.showEditor = this.visibility === 0
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.change-state {
    border: 1px solid var(--color-primary);
    padding: 3px;
}
.state-selector {
    display: flex;
    justify-content: space-evenly;
    min-height: 2.5rem;
    border-radius: 3px;
    cursor: pointer;
    & > * {
        align-self: center;
    }
}
</style>
